import React, { useState } from 'react';
import './Chat.css';

function Chat() {
  const [history, setHistory] = useState([]);
  const [input, setInput] = useState('');
  const [vivaQuestions, setVivaQuestions] = useState([]);
  const [vivaIndex, setVivaIndex] = useState(0);

  async function sendMessage() {
    if (!input.trim()) return;
    const message = input.trim();
    setHistory((h) => [...h, { from: 'user', text: message }]);
    setInput('');

    // if viva mode active
    if (vivaQuestions.length) {
      const current = vivaQuestions[vivaIndex];
      // send answer to viva/answer
      const resp = await fetch('/api/viva/answer', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ question: current.question, userAnswer: message, modelAnswer: current.answer })
      });
      const body = await resp.json();
      setHistory((h) => [...h, { from: 'bot', text: body.comment || JSON.stringify(body) }]);
      if (vivaIndex + 1 < vivaQuestions.length) {
        setVivaIndex(vivaIndex + 1);
      } else {
        setVivaQuestions([]);
        setVivaIndex(0);
        setHistory((h) => [...h, { from: 'bot', text: '🎯 Viva complete! Great job!' }]);
      }
      return;
    }

    // normal chat
    const resp = await fetch('/api/chat', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ message, history: history.map(h => `${h.from}: ${h.text}`) })
    });
    const body = await resp.json();
    setHistory((h) => [...h, { from: 'bot', text: body.reply || JSON.stringify(body) }]);
  }

  async function startViva() {
    const resp = await fetch('/api/viva/start', { method: 'POST' });
    const body = await resp.json();
    if (body.questions) {
      setVivaQuestions(body.questions);
      setVivaIndex(0);
      setHistory((h) => [...h, { from: 'bot', text: `🎓 Viva Mode Activated!\nQ1: ${body.questions[0].question}` }]);
    }
  }

  function switchToNormal() {
    setVivaQuestions([]);
    setVivaIndex(0);
    setHistory((h) => [...h, { from: 'bot', text: '💬 Switched to normal query mode. You can now ask questions.' }]);
  }

  async function validateExperiment() {
    const resp = await fetch('/api/validate');
    const body = await resp.json();
    setHistory((h) => [...h, { from: 'bot', text: body.message || 'Validation complete.' }]);
  }

  return (
    <div className="chat-root">
      <div className="chat-header">Remote Labs Assistant</div>
      <div className="chat-body">
        {history.map((m, i) => (
          <div key={i} className={`chat-msg ${m.from === 'user' ? 'user' : 'bot'}`}>
            <div className="chat-text">{m.text}</div>
          </div>
        ))}
      </div>
      <div className="chat-controls">
        <button onClick={startViva}>🎓 Proceed (Start Viva)</button>
        <button onClick={switchToNormal}>💬 Ask Questions</button>
        <button onClick={validateExperiment}>✅ Validate Experiment</button>
      </div>
      <div className="chat-input">
        <input value={input} onChange={(e) => setInput(e.target.value)} placeholder="Ask about the experiment or answer viva questions..." />
        <button onClick={sendMessage}>Send</button>
      </div>
    </div>
  );
}

export default Chat;
